module.exports = __webpack_public_path__ + "assets/img/swiper-3-2.cb5a5ba6.jpg";